import { Table, Button, Divider } from 'antd/lib';
import React from 'react';

class TablaCategorias extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterDropdownVisible: false,
      verFiltroApellido: false,
      data: this.props.certificaciones,
      textoBuscarNombre: '',
      textoBuscarApellido: '',
      textoBuscarDocumento: '',
      filtered: false,
    };
  }

  render() {
    const columns = [
      {
        title: 'Nombre',
        dataIndex: 'nombre',
        key: 'nombre',
        sortOrder: 'ascend',
        sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      },
      {
        title: 'Descripcion',
        dataIndex: 'descripcion',
        key: 'descripcion',
      },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => (
          <span>
            <Button
              onClick={() =>
                this.props.history.push(`/admin/otros/categorias/${record._id}`)
              }
            >
              Editar
            </Button>
            <Divider type="vertical" />
            <Button
              type="danger"
              onClick={() => this.props.onDelete(record._id)}
            >
              Eliminar
            </Button>
          </span>
        ),
      },
    ];
    const { categorias } = this.props;
    return (
      <Table
        rowKey="_id"
        columns={columns}
        pagination={this.props.pagination}
        dataSource={categorias}
        title={() => <h2 style={{ textAlign: 'center' }}> Categorias </h2>}
        locale={{
          emptyText: 'No hay categorias cargadas',
        }}
      />
    );
  }
}

export default TablaCategorias;
